export const raceTypeList = [
  { label: "第一赛季", value: "season1", image: "m/homePage/d1sj-btn.png" },
  { label: "第二赛季", value: "season2", image: "m/homePage/d2sj-btn.png" },
  { label: "第三赛季", value: "season3", image: "m/homePage/d3sj-btn.png" },
  { label: "第四赛季", value: "season4", image: "m/homePage/d4sj-btn.png" },
  { label: "第五赛季", value: "season5", image: "m/homePage/d5sj-btn.png" },
  { label: "第六赛季", value: "season6", image: "m/homePage/d6sj-btn.png" },
  { label: "第七赛季", value: "season7", image: "m/homePage/d7sj-btn.png" },
  { label: "第八赛季", value: "season8", image: "m/homePage/d8sj-btn.png" },
];

export const groupList = [
  { label: "无极组", value: "group3", image: "race-video/m/wj.png" },
  { label: "纵横组 ", value: "group2", image: "race-video/m/zh.png" },
  { label: "勇武组", value: "group1", image: "race-video/m/yw.png" },
];

export const raceInfoList = [
  {
    label: "精彩集锦",
    value: "highlight",
    image: "race-video/m/se-1-actbtn.png",
  },
  {
    label: "比赛回放",
    value: "playback",
    image: "race-video/m/se-2-actbtn.png",
  },
];

export const raceTypeListPc = [
  {
    label: "第一赛季",
    value: "season1",
    image: "pc/homePage/d1sj-btn.png",
  },
  {
    label: "第二赛季",
    value: "season2",
    image: "pc/homePage/d2sj-btn.png",
  },
  {
    label: "第三赛季",
    value: "season3",
    image: "pc/homePage/d3sj-btn.png",
  },
  {
    label: "第四赛季",
    value: "season4",
    image: "pc/homePage/d4sj-btn.png",
  },
  {
    label: "第五赛季",
    value: "season5",
    image: "pc/homePage/d5sj-btn.png",
  },
  {
    label: "第六赛季",
    value: "season6",
    image: "pc/homePage/d6sj-btn.png",
  },
  {
    label: "第七赛季",
    value: "season7",
    image: "pc/homePage/d7sj-btn.png",
  },
  {
    label: "第八赛季",
    value: "season8",
    image: "pc/homePage/d8sj-btn.png",
  },
];

export const groupListPc = [
  { label: "无极组", value: "group3", image: "race-video/pc/wj.png" },
  { label: "纵横组 ", value: "group2", image: "race-video/pc/zh.png" },
  { label: "勇武组", value: "group1", image: "race-video/pc/yw.png" },
];
